
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/BlogViewAllPostsPage/BlogViewAllPostsPage",
      function () {
        return require("private-next-pages/blogs/BlogViewAllPostsPage/BlogViewAllPostsPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/BlogViewAllPostsPage/BlogViewAllPostsPage"])
      });
    }
  